/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
/** パートナー、子どもの存在を表すルールに使う */
export type AttackListSenderSettingRuleExistence =
  /** 存在する */
  | 'EXIST'
  /** 存在しない */
  | 'NOT_EXIST'
  /** 指定しない(存在してもしなくてもいい) */
  | 'NOT_SPECIFIED';

export type AttackListSenderSettingRuleGender =
  | 'FEMALE'
  | 'MALE'
  /** 性別は指定しない */
  | 'NOT_SPECIFIED';

export type AttackListSenderSettingRuleInput = {
  age?: AttackListSenderSettingRuleRangeInput | null | undefined;
  ageOfFirstChildRange?: AttackListSenderSettingRuleRangeInput | null | undefined;
  ageOfYoungestChildRange?: AttackListSenderSettingRuleRangeInput | null | undefined;
  annualIncomeRange?: AttackListSenderSettingRuleRangeInput | null | undefined;
  child: AttackListSenderSettingRuleExistence;
  diagnosisType?: DiagnosisType | null | undefined;
  familyAnnualIncomeRange?: AttackListSenderSettingRuleRangeInput | null | undefined;
  gender: AttackListSenderSettingRuleGender;
  investmentRange?: AttackListSenderSettingRuleRangeInput | null | undefined;
  jobId?: string | number | null | undefined;
  karteTopicId?: string | number | null | undefined;
  loanBalanceRange?: AttackListSenderSettingRuleRangeInput | null | undefined;
  partner: AttackListSenderSettingRuleExistence;
  savingRange?: AttackListSenderSettingRuleRangeInput | null | undefined;
  shouldSendIfSameCorporationApproached: boolean;
};

export type AttackListSenderSettingRuleRangeInput = {
  max?: number | null | undefined;
  min?: number | null | undefined;
};

export type CreateAttackListSenderSettingsInput = {
  settings: Array<CreateAttackListSenderSettingsInputSetting>;
};

export type CreateAttackListSenderSettingsInputSetting = {
  body: string;
  isEnabled: boolean;
  plannerEmail: string;
  rule: AttackListSenderSettingRuleInput;
  selections: Array<string>;
  title: string;
};

export type DiagnosisType =
  | 'A'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'F'
  | 'G'
  | 'H';

export type DeleteAllCorporationAttackListSenderSettingsMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAllCorporationAttackListSenderSettingsMutation = { deleteAllCorporationAttackListSenderSettings: { isSucceeded: boolean } };

export type CreateCorporationAttackListSenderSettingsMutationVariables = Exact<{
  input: Types.CreateAttackListSenderSettingsInput;
}>;


export type CreateCorporationAttackListSenderSettingsMutation = { createCorporationAttackListSenderSettings: { isSucceeded: boolean } };

export type RollbackAttackListSenderSettingsMutationVariables = Exact<{
  id: string | number;
}>;


export type RollbackAttackListSenderSettingsMutation = { rollbackCorporationAttackListSenderSettings: any };

export type FetchRevisionsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchRevisionsQuery = { corporationAttackListSenderSettingRevisions: Array<{ id: string, createdAt: TimeString }> };

export type AttackListSenderSettingCsvPageViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type AttackListSenderSettingCsvPageViewerQuery = { viewer: { attackListSender: { available: boolean } } };


export const DeleteAllCorporationAttackListSenderSettingsDocument = gql`
    mutation deleteAllCorporationAttackListSenderSettings {
  deleteAllCorporationAttackListSenderSettings {
    isSucceeded
  }
}
    `;

/**
 * __useDeleteAllCorporationAttackListSenderSettingsMutation__
 *
 * To run a mutation, you first call `useDeleteAllCorporationAttackListSenderSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllCorporationAttackListSenderSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAllCorporationAttackListSenderSettingsMutation();
 */
export function useDeleteAllCorporationAttackListSenderSettingsMutation(options: VueApolloComposable.UseMutationOptions<DeleteAllCorporationAttackListSenderSettingsMutation, DeleteAllCorporationAttackListSenderSettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteAllCorporationAttackListSenderSettingsMutation, DeleteAllCorporationAttackListSenderSettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteAllCorporationAttackListSenderSettingsMutation, DeleteAllCorporationAttackListSenderSettingsMutationVariables>(DeleteAllCorporationAttackListSenderSettingsDocument, options);
}
export type DeleteAllCorporationAttackListSenderSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteAllCorporationAttackListSenderSettingsMutation, DeleteAllCorporationAttackListSenderSettingsMutationVariables>;
export const CreateCorporationAttackListSenderSettingsDocument = gql`
    mutation createCorporationAttackListSenderSettings($input: CreateAttackListSenderSettingsInput!) {
  createCorporationAttackListSenderSettings(input: $input) {
    isSucceeded
  }
}
    `;

/**
 * __useCreateCorporationAttackListSenderSettingsMutation__
 *
 * To run a mutation, you first call `useCreateCorporationAttackListSenderSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCorporationAttackListSenderSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCorporationAttackListSenderSettingsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateCorporationAttackListSenderSettingsMutation(options: VueApolloComposable.UseMutationOptions<CreateCorporationAttackListSenderSettingsMutation, CreateCorporationAttackListSenderSettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateCorporationAttackListSenderSettingsMutation, CreateCorporationAttackListSenderSettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateCorporationAttackListSenderSettingsMutation, CreateCorporationAttackListSenderSettingsMutationVariables>(CreateCorporationAttackListSenderSettingsDocument, options);
}
export type CreateCorporationAttackListSenderSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateCorporationAttackListSenderSettingsMutation, CreateCorporationAttackListSenderSettingsMutationVariables>;
export const RollbackAttackListSenderSettingsDocument = gql`
    mutation rollbackAttackListSenderSettings($id: ID!) {
  rollbackCorporationAttackListSenderSettings(targetRevisionId: $id)
}
    `;

/**
 * __useRollbackAttackListSenderSettingsMutation__
 *
 * To run a mutation, you first call `useRollbackAttackListSenderSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRollbackAttackListSenderSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRollbackAttackListSenderSettingsMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRollbackAttackListSenderSettingsMutation(options: VueApolloComposable.UseMutationOptions<RollbackAttackListSenderSettingsMutation, RollbackAttackListSenderSettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RollbackAttackListSenderSettingsMutation, RollbackAttackListSenderSettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RollbackAttackListSenderSettingsMutation, RollbackAttackListSenderSettingsMutationVariables>(RollbackAttackListSenderSettingsDocument, options);
}
export type RollbackAttackListSenderSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RollbackAttackListSenderSettingsMutation, RollbackAttackListSenderSettingsMutationVariables>;
export const FetchRevisionsDocument = gql`
    query fetchRevisions {
  corporationAttackListSenderSettingRevisions {
    id
    createdAt
  }
}
    `;

/**
 * __useFetchRevisionsQuery__
 *
 * To run a query within a Vue component, call `useFetchRevisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRevisionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchRevisionsQuery();
 */
export function useFetchRevisionsQuery(options: VueApolloComposable.UseQueryOptions<FetchRevisionsQuery, FetchRevisionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchRevisionsQuery, FetchRevisionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchRevisionsQuery, FetchRevisionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchRevisionsQuery, FetchRevisionsQueryVariables>(FetchRevisionsDocument, {}, options);
}
export function useFetchRevisionsLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchRevisionsQuery, FetchRevisionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchRevisionsQuery, FetchRevisionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchRevisionsQuery, FetchRevisionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchRevisionsQuery, FetchRevisionsQueryVariables>(FetchRevisionsDocument, {}, options);
}
export type FetchRevisionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchRevisionsQuery, FetchRevisionsQueryVariables>;
export const AttackListSenderSettingCsvPageViewerDocument = gql`
    query AttackListSenderSettingCsvPageViewer {
  viewer {
    attackListSender {
      available
    }
  }
}
    `;

/**
 * __useAttackListSenderSettingCsvPageViewerQuery__
 *
 * To run a query within a Vue component, call `useAttackListSenderSettingCsvPageViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttackListSenderSettingCsvPageViewerQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAttackListSenderSettingCsvPageViewerQuery();
 */
export function useAttackListSenderSettingCsvPageViewerQuery(options: VueApolloComposable.UseQueryOptions<AttackListSenderSettingCsvPageViewerQuery, AttackListSenderSettingCsvPageViewerQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AttackListSenderSettingCsvPageViewerQuery, AttackListSenderSettingCsvPageViewerQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AttackListSenderSettingCsvPageViewerQuery, AttackListSenderSettingCsvPageViewerQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AttackListSenderSettingCsvPageViewerQuery, AttackListSenderSettingCsvPageViewerQueryVariables>(AttackListSenderSettingCsvPageViewerDocument, {}, options);
}
export function useAttackListSenderSettingCsvPageViewerLazyQuery(options: VueApolloComposable.UseQueryOptions<AttackListSenderSettingCsvPageViewerQuery, AttackListSenderSettingCsvPageViewerQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AttackListSenderSettingCsvPageViewerQuery, AttackListSenderSettingCsvPageViewerQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AttackListSenderSettingCsvPageViewerQuery, AttackListSenderSettingCsvPageViewerQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AttackListSenderSettingCsvPageViewerQuery, AttackListSenderSettingCsvPageViewerQueryVariables>(AttackListSenderSettingCsvPageViewerDocument, {}, options);
}
export type AttackListSenderSettingCsvPageViewerQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AttackListSenderSettingCsvPageViewerQuery, AttackListSenderSettingCsvPageViewerQueryVariables>;